module.exports = __webpack_public_path__ + "static/media/microsoft-store-button.76158423.jpg";